import React from 'react';
import './IconTextButton.less';

export const IconTextButton = ({icon, text, onClick}) => {
	return <div className="icon-text-button" onClick={onClick}>
		<div className="icon-text-button__icon" dangerouslySetInnerHTML={{__html: icon}}/>
		<div className="icon-text-button__text">{text}</div>
	</div>
}
